<!-- Icon tooltips -->
@if (tooltipType !== TooltipEnum.NONE) {
  @if (alignIcon === TooltipAlignmentEnum.RIGHT) {
    <div class="content-wrapper">
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
  }
  @if (!disable) {
    <div class="tooltip-wrapper">
        <span [ngClass]="{
                  'iwp-icon-gen_info_info': tooltipType === TooltipEnum.INFORMATION,
                  'iwp-icon-gen_info_warning': tooltipType === TooltipEnum.WARNING,
                  'iwp-icon-gen_info_error': tooltipType === TooltipEnum.ERROR,
                  'small': iconSize === TooltipIconSizeEnum.SMALL,
                  'medium': iconSize === TooltipIconSizeEnum.MEDIUM
              }"
        class="tooltip-icon"
        data-cy="tooltip-icon"
        [ngbTooltip]="getTooltipContent()"
        container="body"
        [placement]="placement"
        [tooltipClass]="getCssClass()"
        (shown)="emitShown()"
      (hidden)="emitHidden()"></span>
    </div>
  }
  @if (alignIcon === TooltipAlignmentEnum.LEFT) {
    <div class="content-wrapper">
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
  }
}

<!-- No icon tooltips -->
@if (tooltipType === TooltipEnum.NONE) {
  @if (dynamic) {
    <div class="content-wrapper" #tooltipComponent="ngbTooltip"
      [ngbTooltip]="getTooltipContent()"
      [placement]="placement"
      [tooltipClass]="getCssClass()"
      (mouseenter)="disableTooltip($event)"
      container="body"
      data-cy="tooltip-is-dynamic"
      [attr.data-cy-tooltip-is-dynamic-enabled]="showDynamicTooltip"
      [disableTooltip]="showDynamicTooltip"
      (shown)="emitShown()"
      (hidden)="emitHidden()">
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
  }
  @if (!dynamic) {
    <div class="content-wrapper" #tooltipComponent="ngbTooltip"
      [ngbTooltip]="getTooltipContent()"
      [placement]="placement"
      [tooltipClass]="getCssClass()"
      [disableTooltip]="disable"
      container="body"
      data-cy="tooltip-is-static"
      (shown)="emitShown()"
      (hidden)="emitHidden()">
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
  }
}

<!-- String tooltips -->
<ng-template #tooltip>
  @if (!disable && isMessageString()) {
    <ng-container class="content-align-left">
      <p data-cy="tooltip-label" class="tooltip-label">{{message}}</p>
    </ng-container>
  }
  @if (!disable && !isMessageString() && message?.length === 1) {
    <p data-cy="tooltip-label" class="tooltip-label">{{message}}</p>
  }
  @if (!disable && !isMessageString() && message?.length > 1) {
    <div data-cy="tooltip-label-item">
      @if (orderedList) {
        <ol class="tooltip-label-list">
          @for (label of message; track label) {
            <li data-cy="tooltip-list-item">{{label}}</li>
          }
        </ol>
      }
      @if (!orderedList) {
        <ul class="tooltip-label-list">
          @for (label of message; track label) {
            <li>{{label}}</li>
          }
        </ul>
      }
    </div>
  }
</ng-template>

<!-- Template for content into which the tooltip is applied -->
<ng-template #template>
  <ng-content></ng-content>
</ng-template>
